import { useEffect } from "react";

export function ErrorFallback() {
  // 크롤러가 이 화면을 렌더하면 그 문구가 검색 결과 소개글로 박힌다 — 색인에서 제외시킨다
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => {
      meta.remove();
    };
  }, []);

  return (
    <div className="min-h-dvh flex items-center justify-center p-6 text-center">
      <div>
        <h1 className="text-xl font-bold">문제가 발생했어요</h1>
        <p className="mt-2 text-sm text-gray-600">
          잠시 후 다시 시도하거나 홈으로 이동해 주세요.
        </p>

        <div className="mt-4 flex gap-2 justify-center">
          <button
            className="px-3 py-2 rounded border"
            onClick={() =>
              history.length > 1 ? history.back() : (location.href = "/")
            }
          >
            뒤로가기
          </button>
          <button
            className="px-3 py-2 rounded border"
            onClick={() => location.reload()}
          >
            강제 새로고침
          </button>
        </div>
      </div>
    </div>
  );
}
